import { render, staticRenderFns } from "./AdminDataTableItem.vue?vue&type=template&id=0be6b687&scoped=true"
import script from "./AdminDataTableItem.vue?vue&type=script&lang=js"
export * from "./AdminDataTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6b687",
  null
  
)

export default component.exports